import React from 'react';

import { Icon } from './styles';

interface ConlicitasegSignupMessageProps {
  icon: string;
  title: string;
}

const ConlicitasegSignupMessage: React.FC<ConlicitasegSignupMessageProps> = ({
  icon,
  title,
  children,
}) => (
  <div className="text-center py-3">
    <Icon className="material-icons text-success mb-3" aria-hidden="true">
      {icon}
    </Icon>
    <h3 className="font-weight-bold mb-2">{title}</h3>
    <div>{children}</div>
  </div>
);

export default ConlicitasegSignupMessage;
